{
    "Accessibility menu": "Accessibilitéitsmenü",
    "Close": "Zoumaachen",
    "Text and Reading": "Text a Liesen",
    "Navigation and Interaction": "Navigatioun an Interaktioun",
    "Text Align": "Textausriichtung",
    "Align Left": "Lénks ausriichten",
    "Align Center": "Zentréieren",
    "Align Right": "Riets ausriichten",
    "Adjust Font Size": "Schrëftgréisst unpassen",
    "Highlight Title": "Titel markéieren",
    "Highlight Links": "Links markéieren",
    "Readable Font": "Liesbar Schrëft",
    "Color and Contrast": "Faarf a Kontrast",
    "Dark Contrast": "Däischteren Kontrast",
    "Light Contrast": "Hellen Kontrast",
    "High Contrast": "Héijen Kontrast",
    "High Saturation": "Héich Saturatioun",
    "Low Saturation": "Niddreg Saturatioun",
    "Monochrome": "Monochrom",
    "Tools": "Tools",
    "Reading Guide": "Guide fir ze liesen",
    "Big Cursor": "Groussen Cursor",
    "Increase Font Size": "Schrëftgréisst erhéijen",
    "Decrease Font Size": "Schrëftgréisst ernidderegen",
    "Letter Spacing": "Zeechenofstand",
    "Line Height": "Linnenhéicht",
    "Font Weight": "Schrëftgewiicht",
    "Dyslexia Font": "Schrëft fir Dyslexie",
    "Language": "Sprooch",
    "Accessibility widget": "Accessibilitéitsmenü opmaachen",
    "Accessibility Profiles": "Accessibilitéits-Profiler",
    "Cognitive Disability": "Kognitiv Behënnerung",
    "Seizure Safe": "Sécher fir Epilepsie",
    "Accessibility statement": "Accessibilitéitserklärung",
    "ADHD": "ADHS",
    "Low Vision": "Schwaach Vue",
    "Pause Animations": "Animatiounen stoppen",
    "Animation paused": "Animatioun pauséiert",
    "Reset all settings": "Astellungen zrécksetzen",
    "Shortcut:": "Tastekierzel:",
    "Epilepsy Safe Mode": "Epilepsie-séchere Modus",
    "Mute sounds": "Téin ausschalten",
    "Page read": "Säit virliesen",
    "Page read controls": "Virlies-Steierung",
    "Pause": "Paus",
    "Resume": "Weiderfueren",
    "Stop": "Stop",
    "Settings": "Astellungen",
    "Speed": "Vitesse",
    "Voice": "Stëmm",
    "Close accessibility menu": "Accessibilitéitsmenü zoumaachen",
    "Back to accessibility menu": "Zréck zum Accessibilitéitsmenü",
    "Search languages": "Sproochen sichen",
    "Selected language": "Ausgewielte Sprooch",
    "View accessibility statement (opens in new window)": "Accessibilitéitserklärung weisen (geet an engem neie Fënster op)",
    "Visit CookieYes website (opens in new window)": "CookieYes-Websäit besichen (geet an engem neie Fënster op)",
    "Reset all accessibility settings to default": "All Accessibilitéitsastellungen zrécksetzen"
}
